var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',_vm._g(_vm._b({attrs:{"sort":true},on:{"start":_vm.onStart,"end":_vm.onEnd}},'draggable',_vm.$attrs,false),_vm.$listeners),[_c('transition-group',{staticClass:"draggable-group"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }